import React, { useState } from "react";

import { useNavigate } from "react-router-dom";

import CompletionModal from "../components/CompletionModal";

import "../styles/Quiz.css";

const QuizResult = () => {
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);

  const completed = localStorage.getItem("course103-assessment-completed");

  if (completed) {
    return (
      <div className="quiz-page">
        <div className="quiz-card">
          <h2>Assessment Already Submitted</h2>

          <p>You have already completed this assessment.</p>
        </div>
      </div>
    );
  }

  const submitAssessment = () => {
    localStorage.setItem("course103-assessment-completed", "true");

    navigate("/assessment-completed");
  };

  return (
    <div className="quiz-page">
      <div className="quiz-card">
        <h1>Assessment Summary</h1>

        <div className="summary-item">✅ Section A Completed</div>

        <div className="summary-item">✅ Section B Completed</div>

        <button className="quiz-btn" onClick={() => setShowModal(true)}>
          Submit Assessment
        </button>
      </div>

      {showModal && <CompletionModal onConfirm={submitAssessment} />}
    </div>
  );
};

export default QuizResult;
